module.exports = __webpack_public_path__ + "assets/img/scene.4c7519f4.jpg";